import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components';
import styles from './ProductCard.module.scss';

export default function ProductCard({ product, onOpen }) {
  const navigate = useNavigate();

  // Hide if out of stock (frontend safety check)
  if (product.stock !== undefined && product.stock <= 0) return null;

  const handleOpen = (e) => {
    // Prevent navigation if clicking on badge
    if (e.target.closest && e.target.closest('.' + styles.shopBadge)) return;

    if (typeof onOpen === 'function') return onOpen(product.id);
    navigate('/product', { state: { id: product.id } });
  };

  const handleShopClick = (e) => {
    e.stopPropagation();
    // Navigate to shop detail if implemented, for now just log or do nothing or filter
    // navigate('/shop/' + product.shop.slug);
  };

  // format price: show integer part without decimals and append '���'
  const formatPrice = (p) => {
    if (p == null || p === '') return '';
    // try to convert to number, tolerate comma decimals
    let n = Number(p);
    if (Number.isNaN(n)) {
      const s = String(p).replace(/\s+/g, '').replace(',', '.');
      n = parseFloat(s);
    }
    if (Number.isNaN(n)) return String(p);
    const intPart = Math.trunc(n);
    return `${intPart} ₽`;
  };

  return (
    <div className={styles.card} onClick={handleOpen}>
      <div className={styles.imageWrap}>
        {product.main_image ? (
          <img src={product.main_image} alt={product.name} className={styles.image} />
        ) : (
          <div className={styles.noImage}>{product.name}</div>
        )}

        {/* Shop Badge */}
        {product.shop && (
            <div className={styles.shopBadge} onClick={handleShopClick} title={product.shop.name}>
                {product.shop.logo && <img src={product.shop.logo} alt={product.shop.name} />}
                <span>{product.shop.name}</span>
            </div>
        )}
      </div>
      
      <div className={styles.content_prod}>
        {product.category_name && <div className={styles.category}>{product.category_name}</div>}
        <div className={styles.title} title={product.name}>{product.name}</div>
        
        <div className={styles.priceRow}>
          <div className={styles.price}>{formatPrice(product.price)}</div>
        </div>
        
        <div className={styles.actions}>
           <Button onClick={handleOpen} className={styles.btnFull}>���������</Button>
        </div>
      </div>
    </div>
  );
}
